let currentVariantId;
let productData;
let arrayOfSwymCollectionsButtons;
let variantImagesArray;
let selectedVariant = {};
let globalActionArray = [];
let globalListArray = [];
let globalProductsInListArray = [];
let selectCallBackObj = [];
let productURL;

function customErrorHandling(error) {
  _swat.ui.uiRef.showErrorNotification({ message: error });
}

function customSuccessHandling(success) {
  _swat.ui.uiRef.showSuccessNotification({ message: success });
}

function performListAction(event) {
  let listId = event.target.getAttribute("list-id");
  let variantInList =
    event.target.getAttribute("variantExistsInList") === "true"; // Convert to boolean

  var product = {
    epi: currentVariantId,
    empi: productData.product.id,
    du: productURL,
  };

  function updateGlobalListArray() {
    _swat.fetchLists({
      callbackFn: function (lists) {
        globalListArray = lists;
        globalListArray.forEach((list) => {
          let listElement = document.querySelector(
            `.swym-custom-list-button[data-list-id="${list.lid}"]`
          );
          if (listElement) {
            listElement.innerHTML = `${list.lname} (${list.listcontents.length})`;
          }
        });
      },
      errorFn: function (error) {
        console.log("Error while fetching all Lists", error);
      },
    });
  }

  if (variantInList) {
    // Remove product
    let onSuccess = function (deletedProduct) {
      event.target.setAttribute("variantexistsinlist", "false");
      event.target.innerHTML = "Add";
      updateGlobalListArray(); // Update global list array after removal
      generateUpdateMessage();
    };

    let onError = function (error) {
      console.log("Error while deleting the Product", error);
    };

    _swat.deleteFromList(listId, product, onSuccess, onError);
  } else {
    // Add product
    let onSuccess = function (addedListItem) {
      event.target.setAttribute("variantexistsinlist", "true");
      event.target.innerHTML = "Remove";
      let listName = event.target.getAttribute("list-name");
      updateGlobalListArray();
      let updateMessage = `${productData.product.title} has been successfully added to ${listName}`;
      customSuccessHandling(updateMessage);
    };

    let onError = function (error) {
      console.log("Error while adding the Product to the List", error);
    };

    _swat.addToList(listId, product, onSuccess, onError);
  }
}

function onSwymLoadCallback(swat) {
  // Dispatch custom event to signal that Swym collections logic has loaded
  const swymLoadedEvent = new CustomEvent("swymCollectionsLoaded", {
    detail: { swat: swat },
    bubbles: true,
  });
  document.dispatchEvent(swymLoadedEvent);

  // Listen for custom event to reinitialize the collections logic
  document.addEventListener("reinitializeSwymCollections", function (event) {
    console.log("Reinitializing Swym Collections Logic...");
    // Re-run the initialization
    addEventListeners();
    persistWishlistButtonsState();
  });

  const currentLanguage = swat.retailerSettings.UI.Language
    ? swat.retailerSettings.UI.Language
    : "english";
  const swymCollectionsModal = document.getElementById(
    "swym-custom-collections-modal-background"
  );
  const desktopModalTitle = document.getElementById("swym-custom-modal-title");
  const multipleListParentContainer = document.getElementById(
    "swym-custom-multiple-list-parent-container"
  );
  const selectPreferenceText = document.getElementById(
    "swym-custom-select-preference-text"
  );
  const selectListsText = document.getElementById(
    "swym-custom-select-wishlists-text"
  );
  const createListGuideText = document.getElementById("swym-list-guide-text");
  const webpageBody = document.querySelector("body");
  const modalCloseButton = document.getElementById("swym-custom-modal-close");
  const mobileModalTitle = document.getElementById("swym-custom-mobile-title");
  const createListModalTitle = document.getElementById(
    "swym-create-list-title"
  );
  const variantSelectionContainer = document.getElementById(
    "swym-custom-variant-selector-container"
  );
  const addToWishlistButton = document.getElementById(
    "swym-custom-add-to-wishlist-button"
  );
  const isSingleWishlist = !swat.retailerSettings.Wishlist.EnableCollections;
  const listIdContainer = document.getElementById(
    "swym-custom-list-id-container"
  );
  const createListButton = document.getElementById(
    "swym-custom-create-list-button"
  );
  const confirmListNameButton = document.getElementById(
    "swym-custom-confirm-list-button"
  );
  const createListContainer = document.getElementById("swym-custom-backdrop");
  const cancelListCreationButton = document.getElementById(
    "swym-custom-notconfirm-list-button"
  );
  const listNameInput = document.getElementById(
    "swym-custom-new-list-name-input"
  );
  const variantImage = document.getElementById("swym-custom-primary-image");
  const vendorTitle = document.getElementById("swym-custom-vendor-title");
  const productTitle = document.getElementById("swym-custom-product-title");
  const price = document.getElementById("swym-custom-variant-price");
  const variantTitle = document.getElementById("swym-custom-variant-title");
  const imgBlobContainer = document.getElementById(
    "swym-custom-image-blob-container"
  );
  const imageSliderContainer = document.getElementById(
    "swym-custom-images-slide-container"
  );
  const prevButton = document.getElementById("swym-custom-slide-arrow-prev");
  const nextButton = document.getElementById("swym-custom-slide-arrow-next");

  const translationsObject = {
    english: {
      defaultWishlistTitle: themeSettings.defaultWishlistTitle,
      desktopModalTitle: themeSettings.desktopModalTitle,
      addedToSingleList: themeSettings.addedToSingleList,
      addedToMultipleLists: themeSettings.addedToMultipleLists,
      selectPreferenceText: themeSettings.selectPreferenceText,
      selectWishlistText: themeSettings.selectWishlistText,
      createListButtonText: themeSettings.createListButtonText,
      createListInputPlaceHolder: themeSettings.createListInputPlaceHolder,
      addToWishlistTextNoListSelected:
        themeSettings.addToWishlistTextNoListSelected,
      addToWishlistTextAddState: themeSettings.addToWishlistTextAddState,
      addToWishlistTextUpdateState: themeSettings.addToWishlistTextUpdateState,
      singleWishlistButtonAddText: themeSettings.singleWishlistButtonAddText,
      singleWishlistButtonRemoveText:
        themeSettings.singleWishlistButtonRemoveText,
      createListModalTitle: themeSettings.createListModalTitle,
      createListGuideText: themeSettings.createListGuideText,
      confirmNewListButtonText: themeSettings.confirmNewListButtonText,
      notificationAddText: themeSettings.notificationAddText,
      notificationRemoveText: themeSettings.notificationRemoveText,
      notificationUpdateText: themeSettings.notificationUpdateText,
      listNameError: themeSettings.listNameError,
      listNameNotUniqueError: themeSettings.listNameNotUniqueError,
      listLimitErrorMessage: themeSettings.listLimitErrorMessage,
    },
  };

  const currentLanguageOption = translationsObject[currentLanguage]
    ? translationsObject[currentLanguage]
    : translationsObject["english"];
  const defaultWishlistTitle = currentLanguageOption.defaultWishlistTitle;

  (function addTextToModal() {
    desktopModalTitle.textContent = currentLanguageOption.desktopModalTitle;
    selectPreferenceText.textContent =
      currentLanguageOption.selectPreferenceText;
    selectListsText.textContent = currentLanguageOption.selectWishlistText;
    createListButton.textContent = currentLanguageOption.createListButtonText;
    createListGuideText.textContent = currentLanguageOption.createListGuideText;
    createListModalTitle.textContent =
      currentLanguageOption.createListModalTitle;
    confirmListNameButton.textContent =
      currentLanguageOption.confirmNewListButtonText;
    listNameInput.setAttribute(
      "placeholder",
      currentLanguageOption.createListInputPlaceHolder
    );
  })();

  function debounce_leading(func, timeout = 300) {
    let timer;
    return (...args) => {
      if (!timer) {
        func.apply(this, args);
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = undefined;
      }, timeout);
    };
  }

  async function persistWishlistButtonsState() {
    return new Promise((resolve, reject) => {
      let onSuccess = function (lists) {
        globalListArray = lists;

        if (lists.length < 1 && isSingleWishlist) {
          let listConfig = {
            lname: "My Wishlist",
          };

          let onSuccess = function (newList) {
            updateGlobalListArray();
          };

          let onError = function (error) {
            console.log("Error while creating a List", error);
          };

          swat.createList(listConfig, onSuccess, onError);
        }
        lists.forEach((list) => {
          list.listcontents.forEach((product) => {
            let productId = product.empi;
            let buttonToFill = document.querySelector(
              `button#swym-collections[data-product-id="${productId}"]`
            );
            if (
              buttonToFill &&
              !buttonToFill.classList.contains("swym-added")
            ) {
              SwymUtils.addClass(buttonToFill, "swym-added");
            }
          });
        });
        resolve();
      };

      let onError = function (error) {
        console.error("Error while fetching all Lists", error);
        reject(error);
      };

      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      });
    });
  }

  async function handleRemoveFromWishlistButtonState(productId) {
    try {
      await persistWishlistButtonsState();
      const productIdExistsInSomeList = globalListArray.some((list) =>
        list.listcontents.some((product) => product.empi === productId)
      );

      if (!productIdExistsInSomeList) {
        const buttonToUnFill = document.querySelector(
          `button#swym-collections[data-product-id="${productId}"]`
        );
        if (buttonToUnFill) {
          SwymUtils.removeClass(buttonToUnFill, "swym-added");
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  function handleAddedToWishlistButtonState(productId) {
    let buttonToFill = document.querySelector(
      `button#swym-collections[data-product-id="${productId}"]`
    );
    if (buttonToFill && !buttonToFill.classList.contains("swym-added")) {
      SwymUtils.addClass(buttonToFill, "swym-added");
    }
  }

  swat.evtLayer.addEventListener(
    swat.JSEvents.removedFromWishlist,
    function (data) {
      let productId = data.detail.d.empi;
      handleRemoveFromWishlistButtonState(productId);
    }
  );
  swat.evtLayer.addEventListener(
    swat.JSEvents.addedToWishlist,
    function (data) {
      let productId = data.detail.d.empi;
      handleAddedToWishlistButtonState(productId);
    }
  );

  function showZoomedView(e) {
    const zoomedView = document.createElement("div");
    const zoomedImage = new Image();
    SwymUtils.addClass(zoomedView, "zoomed-image");
    zoomedImage.src = e.target.src;
    zoomedView.appendChild(zoomedImage);

    const closeButton = document.createElement("button");
    closeButton.setAttribute("aria-label", "Close zoomed image");
    closeButton.classList.add("swym-zoomed-image-close-button", "close-button");
    closeButton.innerHTML = "&times;";
    closeButton.addEventListener("click", () => {
      document.body.removeChild(zoomedView);
    });
    zoomedView.appendChild(closeButton);

    document.body.appendChild(zoomedView);

    zoomedView.addEventListener("click", (event) => {
      if (event.target === zoomedView) {
        document.body.removeChild(zoomedView);
      }
    });
  }

  function addImgBlobClickListener(event) {
    const imgBlobSrc = event.target.getAttribute("src");
    const allImgBlobs = document.querySelectorAll("#swym-custom-image-blob");
    variantImage.src = imgBlobSrc;

    allImgBlobs.forEach((imgBlob) => {
      if (imgBlob !== event.target) {
        imgBlob.classList.remove("selected");
      }
    });

    SwymUtils.toggleClass(event.target, "selected");
  }

  function addImageSliderEventListeners() {
    const slide = document.querySelector(".swym-custom-slider-image");
    nextButton.addEventListener("click", () => {
      const slideWidth = slide.clientWidth;
      imageSliderContainer.scrollLeft += slideWidth;
    });

    prevButton.addEventListener("click", () => {
      const slideWidth = slide.clientWidth;
      imageSliderContainer.scrollLeft -= slideWidth;
    });
  }

  function initializeSwipeableImageSlider() {
    let imageSlides = [];

    variantImagesArray.forEach((image, index) => {
      const imageSlide = document.createElement("img");
      imageSlide.src = image.src.replace('.jpg', '_500x.jpg').replace('.png', '_500x.png').replace('.webp', '_500x.webp');
      imageSlide.ariaLabel = `product-image-${index}`;
      imageSlide.className = "swym-custom-slider-image";
      imageSlide.width = "250";
      imageSlide.height = "250";
      imageSlide.addEventListener("click", showZoomedView);

      imageSlides.push(imageSlide);
      imageSliderContainer.appendChild(imageSlide);
    });

    addImageSliderEventListeners();
  }

  function addImageCarousel() {
    variantImagesArray = productData.product.images;
    initializeSwipeableImageSlider();
    const imgTags = variantImagesArray.map((image, index) => {
      const imgTag = document.createElement("img");
      imgTag.width = "24";
      imgTag.height = "24";
      imgTag.ariaLabel = `Product Secondary Image-${index}`;
      imgTag.id = `swym-custom-image-blob`;
      imgTag.src = image.src;

      imgTag.addEventListener("click", addImgBlobClickListener);

      return imgTag;
    });

    imgBlobContainer.innerHTML = "";
    imgBlobContainer.append(...imgTags);
  }

  function updateListHandler() {
    let listInputs = document.querySelectorAll(".swym-custom-list-button");
    globalActionArray = [];
    listInputs.forEach((input) => {
      if (!input.checked && input.classList.contains("variant-in-wishlist")) {
        globalActionArray.push({
          actionType: "remove",
          listId: `${input.getAttribute("data-list-id")}`,
        });
      } else if (
        input.checked &&
        !input.classList.contains("variant-in-wishlist")
      ) {
        globalActionArray.push({
          actionType: "add",
          listId: `${input.getAttribute("data-list-id")}`,
        });
      }
    });
    toggleAddToWishlistButtonState();
  }

  function isVariantPresentInLists() {
    if (!isSingleWishlist) {
      globalListArray.forEach((list) => {
        const listId = list.lid;
        const listInput = document.querySelector(
          `#swym-list-action-btn[list-id="${listId}"]`
        );
        const variantIsPresent =
          listInput &&
          list.listcontents.some((variant) => variant.epi === currentVariantId);

        if (listInput) {
          listInput.setAttribute("variantexistsinlist", variantIsPresent);
          if (variantIsPresent) {
            listInput.innerHTML = "Remove";
          } else {
            listInput.innerHTML = "Add";
          }
        }
      });
    } else {
      const variantInWishlist = globalProductsInListArray.some(
        (product) => product.epi === currentVariantId
      );

      addToWishlistButton.classList.toggle(
        "variant-in-wishlist",
        variantInWishlist
      );
      addToWishlistButton.textContent = variantInWishlist
        ? currentLanguageOption.singleWishlistButtonRemoveText
        : currentLanguageOption.addToWishlistTextAddState;
    }
    toggleAddToWishlistButtonState();
  }

  function listSelectionEventlistener() {
    const listInputs = document.querySelectorAll(".swym-custom-list-button");
    listInputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        if (e.target.classList.contains("selected")) {
          e.target.classList.remove("selected");
        } else {
          e.target.classList.add("selected");
        }
        updateListHandler();
      });
    });
    isVariantPresentInLists();
  }

  function addWishlists() {
    if (!isSingleWishlist) {
      multipleListParentContainer.classList.remove("swym-hide-container");
      createListButton.classList.remove("swym-hide-container");
      addToWishlistButton.innerHTML = "Done";

      const onSuccess = (lists) => {
        globalListArray = lists;
        const listItemsHTML = lists
          .map((list) => {
            let variantExistsInList = list.listcontents.some(
              (product) => product.epi == currentVariantId
            );
            return `
                    <div id="swym-list-action-wrapper" class="swym-global-font-family">
                        <div id="${list.lid}-${
              productData.product.id
            }" list-name="${list.lname}" aria-label="Select ${
              list.lname
            }" class="swym-custom-list-button" type="checkbox" data-list-id="${
              list.lid
            }">${list.lname} (${list.listcontents.length})</div>
                        <button list-id="${list.lid}" list-name="${
              list.lname
            }" onclick="performListAction(event)" id="swym-list-action-btn" variantExistsInList="${variantExistsInList}">${
              variantExistsInList ? "Remove" : "Add"
            }</button>
                    </div>`;
          })
          .join("");

        listIdContainer.innerHTML = listItemsHTML;

        listSelectionEventlistener();
        isVariantPresentInLists();

        if (globalListArray.length < 1) {
          createListButton.click();
        }

        toggleVariantData();
      };

      const onError = (error) => customErrorHandling(error.description);

      swat.fetchLists({ callbackFn: onSuccess, errorFn: onError });
    } else if (isSingleWishlist) {
      swat.fetch(
        (allWishlistedProducts) => {
          globalProductsInListArray = allWishlistedProducts;
          isVariantPresentInLists();
        },
        (error) => customErrorHandling(error.description)
      );

      toggleVariantData();
    }
  }

  function toggleVariantData() {
    getSelectedVariant(selectCallBackObj);

    const currentProductTitle = productData.product.title;
    const currentProductVendor = productData.product.vendor;
    const alterNateVariantImages = productData.product.images;
    const currentVariantTitle = selectedVariant.title.replace(/\//g, "");
    const currentVariantPrice = swat.currency + " " + selectedVariant.price;
    const imageId = selectedVariant.image_id;

    vendorTitle.innerHTML = "By: " + currentProductVendor;
    productTitle.innerHTML = currentProductTitle;
    variantTitle.innerHTML = currentVariantTitle;
    price.innerHTML = currentVariantPrice;

    for (let i = 0; i < alterNateVariantImages.length; i++) {
      if (alterNateVariantImages[i].id == imageId) {
        variantImage.setAttribute("src", alterNateVariantImages[i].src);
      } else {
        variantImage.setAttribute("src", productData.product.image.src);
      }
    }
  }

  function addProductData() {
    const product = productData.product;
    variantImage.src = product.image.src;
    vendorTitle.innerHTML = product.vendor;
    productTitle.innerHTML = product.title;
    mobileModalTitle.textContent = product.title;
    price.innerHTML = product.variants[0].price;

    addWishlists();
    addImageCarousel();
    renderVariantSelectors(productData);
  }

  (function () {
    function showCreateListContainer() {
      const newWishlistTitle =
        defaultWishlistTitle + " " + (globalListArray.length + 1);

      if (globalListArray.length >= 10) {
        customErrorHandling(currentLanguageOption.listLimitErrorMessage);
      } else {
        createListContainer.classList.remove("swym-hide-container");
        createListButton.setAttribute("disabled", true);
        listNameInput.value = newWishlistTitle;
        listNameInput.select();
      }
    }

    function hideCreateListContainer() {
      createListContainer.classList.add("swym-hide-container");
      createListButton.removeAttribute("disabled");
    }

    createListButton.addEventListener("click", showCreateListContainer);
    cancelListCreationButton.addEventListener("click", hideCreateListContainer);

    createListContainer.addEventListener("click", (e) => {
      if (e.target === createListContainer) {
        hideCreateListContainer();
      }
    });
  })();

  (function () {
    confirmListNameButton.addEventListener("click", () => {
      const listName = listNameInput.value.trim();

      if (listName.length < 3 || listName.length > 50) {
        customErrorHandling(currentLanguageOption.listNameError);
        resetListNameInput();
      } else if (isListNameAlreadyExists(listName)) {
        const errorMessage = `${listName} ${currentLanguageOption.listNameNotUniqueError}`;
        customErrorHandling(errorMessage);
        resetListNameInput();
      } else {
        createList(listName);
      }
    });

    function resetListNameInput() {
      listNameInput.value = "";
      listNameInput.focus();
      listNameInput.select();
    }

    function isListNameAlreadyExists(name) {
      return globalListArray.some((list) => list.lname === name);
    }

    function createList(listName) {
      const listConfig = { lname: listName };

      swat.createList(
        listConfig,
        (newList) => {
          addWishlists();
          createListContainer.classList.add("swym-hide-container");
          createListButton.removeAttribute("disabled");
        },
        (error) => customErrorHandling(error.description)
      );
    }
  })();

  function toggleAddToWishlistButtonState() {
    if (!isSingleWishlist) {
      if (globalActionArray.length === 0) {
        // addToWishlistButton.setAttribute("disabled", true);
        // addToWishlistButton.textContent = currentLanguageOption.addToWishlistTextNoListSelected;
      } else {
        const hasRemoveAction = globalActionArray.some(
          (action) => action.actionType === "remove"
        );
        addToWishlistButton.removeAttribute("disabled");
        addToWishlistButton.textContent = hasRemoveAction
          ? currentLanguageOption.addToWishlistTextUpdateState
          : currentLanguageOption.addToWishlistTextAddState;
      }
    }
  }

  function updateVariantInLists() {
    const product = {
      epi: currentVariantId,
      empi: productData.product.id,
      du: productURL,
    };

    if (!isSingleWishlist) {
      setTimeout(() => {
        closeCollectionsModal();
      }, 100);
    } else {
      handleSingleWishlist(product);
    }

    setTimeout(() => {
      closeCollectionsModal();
    }, 100);
  }

  const closeBtn = document.querySelector('[data-wishlist-popup-close]');
  const modalBg = document.querySelector('.swym-custom-collections-modal-background--login');

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modalBg.classList.remove('open');
    });
  }

  function handleAddToListFromURL() {
    let onSuccess = function(lists) {
      if (window.loggedIn) {
        let lid = lists[0]?.lid;
        const url = new URL(window.location.href);
        const params = url.searchParams;

        const hasEpi  = params.has("epi");
        const hasEmpi = params.has("empi");
        const hasDu   = params.has("du");

        if (hasEpi && hasEmpi && hasDu) {

          const product = {
            epi:  Number(params.get("epi")),
            empi: Number(params.get("empi")),
            du:   params.get("du")
          };

          let onSuccess = function (addedListItem){}

          let onError = function (error){
            console.log("Error while adding the Product to the List", error);
          }

          swat.addToList(lid, product, onSuccess, onError);
          const updateMessage = `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationAddText}`;
          customSuccessHandling(updateMessage);

          params.delete("epi");
          params.delete("empi");
          params.delete("du");

          window.history.replaceState({}, "", url.toString());
        }
      }
    }

    let onError = function(error) {

      console.log("Error while fetching all Lists", error);
    }

    swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError
    });
  }


  handleAddToListFromURL();



  function handleSingleWishlist(product) {
    let lid = globalListArray[0]?.lid;

    const modalBg = document.querySelector('.swym-custom-collections-modal-background--login');
    

    let onSuccess = function (addedListItem) {};

    let onError = function (error) {
      console.log("Error while adding the Product to the List", error);
    };

    if (!addToWishlistButton.classList.contains("variant-in-wishlist")) {
      if (window.loggedIn) {
        swat.addToList(lid, product, onSuccess, onError);
        const updateMessage = `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationAddText}`;
        customSuccessHandling(updateMessage);
      } else {
        const params = new URLSearchParams(product).toString();
        const form = document.querySelector('.wishlist-login-form form');
        if (!form) return;
        const urlPath = window.location.pathname + `?${params}`;
        const returnInput = form.querySelector('input[name="return_to"]');
        if (returnInput) {
          returnInput.value = urlPath;
        }
        setTimeout(() => {
          modalBg.classList.add('open');
        }, 100);
      }
    } else {
      swat.deleteFromList(lid, product, onSuccess, onError);
      const updateMessage = `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationRemoveText}`;
      customSuccessHandling(updateMessage);
    }
  }

  function convertObjectToString(selectCallBackObj) {
    return Object.values(selectCallBackObj).join(" / ");
  }

  function getSelectedVariant(selectCallBackObj) {
    globalActionArray = [];
    const variants = productData.product.variants;
    let variantComboUnavailable = false;
    variants.forEach((variant) => {
      const filterTitle = convertObjectToString(selectCallBackObj);
      if (filterTitle == variant.title) {
        variantComboUnavailable = true;
        selectedVariant = variant;
        currentVariantId = variant.id;
      }
    });
    if (!variantComboUnavailable) {
      addToWishlistButton.setAttribute("disabled", true);
      addToWishlistButton.textContent = "Combination Unavailable";
    } else {
      addToWishlistButton.removeAttribute("disabled");
      addToWishlistButton.textContent = "Done";
    }

    isVariantPresentInLists();
  }

  function handleRadioButtonClick(event) {
    const selectedValue = event.target.value;
    const optionIndex = event.currentTarget.getAttribute("optionIndex");

    selectCallBackObj = {
      ...selectCallBackObj,
      [optionIndex]: selectedValue,
    };

    const labels = event.currentTarget.parentNode.querySelectorAll(
      `label[for="${event.target.id}"]`
    );
    labels.forEach((label) => {
      label.classList.add("selected");
    });

    const unselectedRadios = event.currentTarget.parentNode.querySelectorAll(
      `input[type="radio"]:not([value="${selectedValue}"])`
    );
    unselectedRadios.forEach((radio) => {
      const labels = event.currentTarget.parentNode.querySelectorAll(
        `label[for="${radio.id}"]`
      );
      labels.forEach((label) => {
        label.classList.remove("selected");
      });
    });

    toggleVariantData();
  }

  function createRadioGroup(option, optionIndex) {
    const variantOptions = option.values
      .map((value) => {
        const isSelected = value == selectedVariant[`option${optionIndex + 1}`];
        return `<input style="display: none;" selected="${isSelected}" id="${option.name}-${value}" type="radio" name="${option.name}" optionIndex="${optionIndex}" value="${value}" aria-label="${option.name} ${value}"></input>
                        <label class="swym-filter-labels" for="${option.name}-${value}">${value}</label>`;
      })
      .join("");

    const radioGroup = document.createElement("div");
    radioGroup.setAttribute("class", `${option.name} swym-filter-option-name`);
    radioGroup.innerHTML = `<div id="swymOptionName" selected value="${option.name}">Select ${option.name}</div>
                                  <div class="swym-radio-buttons-container">${variantOptions}</div>`;

    const radioButtons = radioGroup.querySelectorAll(`[name="${option.name}"]`);
    for (let i = 0; i < radioButtons.length; i++) {
      radioButtons[i].addEventListener("click", function (event) {
        handleRadioButtonClick(event, productData);
      });
    }

    return radioGroup;
  }

  function renderVariantSelectors() {
    const optionsArray = productData.product.options;
    const variantSelectors = optionsArray.map((option, optionIndex) => {
      return createRadioGroup(option, optionIndex);
    });

    variantSelectionContainer.innerHTML = "";
    variantSelectors.forEach((variantSelector) => {
      variantSelectionContainer.append(variantSelector);
    });

    variantSelectors.forEach((variantSelector) => {
      const radioButtons = variantSelector.querySelectorAll(
        'input[type="radio"]'
      );
      if (radioButtons.length > 0) {
        radioButtons[0].click();
      }
    });
  }

  function closeCollectionsModal() {
    selectCallBackObj = {};
    swymCollectionsModal.classList.add("swym-hide-container");
    webpageBody.classList.remove("swym-modal-active");
    imageSliderContainer.innerHTML = "";
    variantSelectionContainer.innerHTML = "";
    imgBlobContainer.innerHTML = "";
    listIdContainer.innerHTML = "";
  }

  function openCollectionsModal() {
    addProductData(productData);

    swymCollectionsModal.classList.remove("swym-hide-container");
    variantImage.addEventListener("click", showZoomedView);
    webpageBody.classList.add("swym-modal-active");
    globalActionArray = [];

    window.addEventListener("click", (event) => {
      if (event.target === swymCollectionsModal) {
        closeCollectionsModal();
      }
    });
    imageSliderContainer.scrollLeft = 0;
  }

  function fetchProductDetails(event) {
    const rawUrl = event.target.getAttribute("data-product-url");
    productURL = rawUrl.split("?")[0];
    const shopifyProductEndpoint = productURL + ".json";
    fetch(shopifyProductEndpoint)
      .then((res) => res.json())
      .then((productJson) => {
        productData = productJson;
        selectedVariant = productData.product.variants[0];
        openCollectionsModal();
      });
  }

  function addEventListeners() {
    arrayOfSwymCollectionsButtons =
      document.querySelectorAll("#swym-collections");
    if (arrayOfSwymCollectionsButtons) {
      for (let i = 0; i < arrayOfSwymCollectionsButtons.length; i++) {
        arrayOfSwymCollectionsButtons[i].addEventListener(
          "click",
          debounce_leading(fetchProductDetails, 500)
        );
        SwymUtils.addClass(
          arrayOfSwymCollectionsButtons[i],
          "swym-custom-loaded"
        );
      }
    }

    modalCloseButton.addEventListener("click", closeCollectionsModal);
    addToWishlistButton.addEventListener(
      "click",
      debounce_leading(updateVariantInLists, 500)
    );
    addToWishlistButton.addEventListener(
      "touchstart",
      debounce_leading(updateVariantInLists, 1000)
    );
    persistWishlistButtonsState();
  }

  addEventListeners();
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback);
